import * as Yup from 'yup';

export const SignUpOptionsSchema = Yup.object().shape({
  aboutYou: Yup.string().required('Please select your role'),
  role: Yup.string().when('aboutYou', {
    is: 'Role not listed',
    then: (schema) => schema.required('Please enter your role'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export type SignUpOptionsDataType = Yup.InferType<typeof SignUpOptionsSchema>;

type InitialValues = {
  aboutYou: string;
  role: string;
};

export const signUpOptionsInitialValues: InitialValues = {
  aboutYou: '',
  role: '',
};


export interface OptionsSliderInterface {
  aboutYou: string;
  role?: string;
}
